import React, { Component } from 'react';
import './App.css';
import FormCompanyAdd from './FormCompanyAdd';
import NavBar from './NavBar';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { connect } from "react-redux";
import CompanyList from './CompanyList';

class App extends Component {
  componentDidMount() {
    //fetch("./api/companies.json")
    //  .then(response => response.json())
    //  .then(data => this.setState({
    //    companies: data.companies,
    //    selection: data.companies.map(company => Object.assign({}, company))
    //  }));
  }
  render() {
    return (
      <Router>
        <div className="App">
          <div class="container">
            <NavBar onSearchChange={this.props.onSearchChange} />
            <Route path="./" exact component={CompanyList} />
            <Route path="./add" component={FormCompanyAdd} />
          </div>
        </div>
      </Router>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSearchChange: (event) => dispatch({
      type: "SEARCH_CHANGED",
      searchString: event.target.value
  })
})

const mapStateToProps = state => {
  return {
    searchString: state.searchString,
    companies: state.companies,
    selection: state.selection
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App);
